<template>
    <div class="wrap">
        <div class="hd">
            <div class="top">
                <vant-select
                    v-if="isMultiLeagues"
                    :list="joinedLeagues"
                    default="切换组织"
                    optionName="leagueName"
                    type="objectArr"
                    showTitle='no'
                    :defaultValue="defaultValue"
                    @chooseFn="chooseIdentityFn">
                </vant-select>
            </div>
            <div class="bottom">
                <div class="hd_left">
                    <div>
                        <img v-if="user.photoUrl != ''" :src="user.photoUrl" alt="">
                        <img v-else-if="user.userSex == 1" src="../../../static/img/boy.png" alt="">
                        <img v-else src="../../../static/img/girl.png" alt="">
                    </div>
                    <div style="max-width: 75%">
                        <p>{{user.userName}}</p>
                        <p>{{league.leagueFullName}}</p>
                    </div>
                </div>
                <div class="hd_right" v-if="league.isObserver == 1 || league.isLeagueAdmin == 1">
                    <img src="../../../static/img/admincenter.png" alt="" @click="jump('/home')">
                </div>

            </div>
        </div>
        <div class="bd">
            <div class="explain">
                <van-cell is-link title="个人资料" @click="goToInfo" />
            </div>
            <div class="explain">
                <van-cell is-link title="退出登录" @click="logOut" />
            </div>
        </div>
        <div class="ft">

        </div>

    </div>

</template>

<script>
import {mapState} from 'vuex'
import vantSelect from '../../components/vantSelect'
import cons from "@/cons";


export default {
    name: "mine",
    components: {vantSelect},
    data() {
        return {
            staticPath: cons.img,
            leagueOption: {
                "02TZZ": "团总支",
                "03TW": "团委",
                "04TGW": "团工委",
                "05TDLDJG": "团的领导机关",
                "06BYBTZB": "毕业生团组织",
                "00DJZTZB": "待接转团支部",
                "01TZB": "团支部"
            },
            transInitOrDetail:'/transferPersonal',
            joinedLeagues: [],
            selectedLeague: {},
            defaultValue:''
        }
    },
    computed: {
        ...mapState({
            user: state => state.user,
            league: state => state.league,
            commonparams: state => state.commonparams,
            loginedInfo: state => state.loginedInfo,
        }),
        cardInfo() {
            if (this.league.isLeagueAdmin == 1) {
                return "(管理员)"
            } else if (this.league.isObserver == 1) {
                return "(观察员)"
            }
            return ""
        },
        isMultiLeagues() {
            if ('joinedLeagues' in this.loginedInfo && this.loginedInfo['joinedLeagues'].length > 1) {
                return true
            }
            return false
        },
        canTrans() {
            if(this.checkIsTzb(this.league.leagueTypeId)) {
                return true
            }

            return false
        },
        iconSrc() {
            if (this.user.photoUrl == "") {
                if (this.user.userSex == 1) {
                    return this.staticPath + '/img/boy.png'
                }
                else  {
                    return this.staticPath + '/img/girl.png'
                }
            } else {
                return this.user.photoUrl
            }
        },
    },
    created() {
        this.selectedLeague = this.league.leagueId

        if(this.isMultiLeagues) {
            this.joinedLeagues =  this.loginedInfo['joinedLeagues']
        }

        let index =  this.joinedLeagues.findIndex((item,i)=>{
            return item.leagueId === this.league.leagueId
        })
        this.defaultValue = index + 1

        console.log(this.league)

    },
    methods:{
        //该列 是否是团支部
        checkIsTzb(leagueType) {
            if (leagueType == "01TZB" || leagueType == "00DJZTZB" || leagueType == "06BYBTZB") {
                return true
            } else {
                return false
            }

        },
        goToInfo() {
            // check roldId tuanyuan  tuangan
            // 0	未知  1	运营管理员  2	非团员  3	超龄团员  4	团员  5	团干部  6	观察员
            if(this.league.roleId == 5) {
                if(this.league.leagueTypeId=='05TDLDJG') {
                    this.jump('/mine/tuanGanLeaderInfo')
                } else {
                    this.jump('/mine/tuanGanInfo')
                }
            } else {
                this.jump('/mine/info')
            }
            console.log("go to info")
        },
        goToLeagueChange() {
            console.log("goToLeagueChange")
            let self = this
            let param = new FormData()
            param.append("page",1)
            this.PF('/person/initTransferHistory', param, {baseURL: cons.m}).then((response) => {
                this.loading = false
                if (response.status == 200) {
                    if (response.data.retCode === 1000) {
                        let redata = response.data.results
                        let doing = false
                        let bid = ''
                        for (let i=0; i < redata.transferList.length; i++) {
                            if(redata.transferList[i].status === 1 ) {
                                doing = true
                                bid = redata.transferList[i].id
                                break
                            }
                        }
                        if(doing) {
                            let param = {
                                businessId: bid,
                            }
                            this.$store.commit('SET_PARAMS', {'manage/managetransferprocess': param})

                            this.jump('/transferPersonalDetail')
                        } else {
                            this.$dialog.alert({
                                message: '目前暂时关闭在移动端使用当前功能，请前往PC端操作',
                                theme: 'round-button',
                                confirmButtonText:'确定',
                            })
                            // this.jump('/transferPersonal')
                        }


                    } else {
                        self.$dialog.alert({
                            message: response.data.retMsg,
                            theme: 'round-button',
                        }).then(() => {
                            // on close
                        });
                        // this.$notify({
                        //     type: 'danger',
                        //     message: response.data.retMsg
                        // })

                    }
                }
            }).catch((error) => {
                this.loading = false
                console.log(error.config);
            });

        },
        logOut() {
            console.log("logOut")
            let self = this
            let param = new FormData()
            param.append('currLeagueId', this.league.leagueId)
            param.append('currUserId', this.user.userId)

            this.loading = true
            this.$root.PF('/signout', param, {})
                .then(function (response) {
                    console.log(response)
                    self.loading = false

                    if (response.status == 200) {
                        self.$store.commit('CLEAR')
                        self.$store.commit('CLEAR_PARAMS')
                        window && window.localStorage.clear()
                        self.jump('/')
                    }
                })
                .catch(function (error) {
                    if (error.response) {

                    } else if (error.request) {
                        console.log(error.request);

                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message);
                    }
                    console.log(error.config);
                });
        },
        updateLocal(user, league) {
            this.$store.commit('SET_USER', {user})
            this.$store.commit('SET_LEAGUE', {league})
        },
        chooseIdentityFn(theLeague){
            // 修改当前组织
            let switchLeague = {}
            let found = false
            let leagues = this.loginedInfo['joinedLeagues']
            for (let i in leagues) {
                if (leagues[i].leagueId == theLeague.leagueId) {
                    switchLeague = leagues[i]
                    found = true
                    break
                }
            }
            if (found == false) {
                this.$dialog.alert({
                    message: "未找到选择的团组织",
                    theme: 'round-button',
                }).then(() => {
                    // on close
                });
                // this.$notify({
                //     type: 'danger',
                //     message: '未找到选择的团组织',
                // })
                return
            }

            let self = this
            let param = new FormData()
            param.append('switchLeagueId', theLeague.leagueId)
            param.append('userId', self.user.userId)
            this.loading = true
            this.$root.PF('/validSwitchLeague', param, {})
                .then(function (response) {
                    self.loading = false

                    if (response.status == 200) {

                        if (response.data.retCode === 1000) {
                            let isadmin = switchLeague.isLeagueAdmin == 1 ? true : false
                            let isObserver = switchLeague.isObserver == 1 ? true : false
                            let isDefalutLeague = switchLeague.isDefaultLeague == 1 ? true : false
                            let isBelong = switchLeague.isBelong == 1 ? true : false
                            //用于控制发起组织迁移的弹框页面
                            if ('orgmove' in self.commonparams) {
                                delete self.commonparams['orgmove']
                            }
                            if (isadmin) {
                                self.$store.commit('SET_TIPS', {
                                    'showCheckLeader': 1,
                                    'showUserCode': 1,
                                    'showLeaderImport': 1,
                                    "showImport": 1,
                                    "showImportTZB": 1,
                                    "showCheckFullIn": 1,
                                })
                            }
                            let u = self.user
                            window && window.localStorage.clear()
                            self.updateLocal(u, switchLeague)

                            var viewType, router
                            if (isObserver || isadmin) {
                                viewType = 'home'
                                router = '/home'
                                self.jump(router)
                            }

                            self.qm()
                        } else {
                            let msg = response.data.retMsg
                            self.$dialog.alert({
                                message: msg,
                                theme: 'round-button',
                            }).then(() => {
                                // on close
                            });
                            // this.$notify({
                            //     type: 'danger',
                            //     message: msg,
                            // })
                        }
                    } else {
                        console.log("Got Return code:" + response.status)
                        // this.$notify({
                        //     type: 'danger',
                        //     message: '网络异常，请稍后再试'
                        // })
                        self.$dialog.alert({
                            message: '网络异常，请稍后再试',
                            theme: 'round-button',
                        }).then(() => {
                            // on close
                        });
                    }
                })
                .catch(function (error) {
                    if (error.response) {

                    } else if (error.request) {
                        console.log(error.request);

                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message);
                    }
                    console.log(error.config);
                });
        },
        qm() {
            // 查消息相关 暂时不用
        },


    }
}

</script>

<style scoped>

.wrap {
    background-color: #eeedf0;
    height: 100%;
    width: 100%;
}

.hd {
    width: 100%;
    height: 200px;
    background: url("../../../public/img/img-top.png") no-repeat 0 0;
    background-size: 100% 100%;
    /*display: flex;*/
    /*flex-direction: column;*/
}
.hd .top{
    float: right;
    padding: 20px 30px 0 0;
}
.hd .bottom{
    width: 100%;
    display: flex;
    padding-top: 20px;
    align-items: center;
    justify-content: space-between;
}

.hd .hd_left {
    display: flex;
    padding-left: 30px;
    align-items: flex-start;
}

.hd .hd_left img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
}

.hd .hd_left p {
    color: white;
    font-size: 16px;
    margin: 5px 10px;

}

.hd .hd_right {
    padding-right: 20px;
}
.hd .hd_right img{
    height: 30px;
    width: auto;
}

.bd .explain {
    width: 90%;
    border-radius: 5px;
    background-color: white;
    margin: 10px auto;
    display: block;
    padding: 10px;

}

.bd .explain p {
    margin: 0 0 0 10px;
    color: #656565;
    font-size: 15px;
}

.ft {
    width: 95%;
    margin: 0 auto;
    background-color: white;
}

.ft img {
    width: auto;
    height: 40px;
}

.ft p {
    font-size: 14px;
    color: #656565;
    text-align: center;
}

/deep/ .ft .van-grid-item__content {
    padding: 10px 8px;
}
/deep/ .van-dropdown-menu__bar{
    height: 100%;
    box-shadow: none;
    background-color: transparent;
}
/deep/ .van-ellipsis{
    color: white;
}
/deep/ .van-dropdown-menu__title::after{
    border-color: transparent transparent white white;
}


</style>
